module.exports = {
    'payments.address.update': 'user/$1/address/$2',
    'payments.payment-sources.update': 'payments/users/$1/payment-sources',
};
